import { IUCISModel } from "../Interfaces/interface";
import { logUCMetrics } from "../components/InterruptPage/UCMetricsLogger";
import React from "react";

const ucisData: IUCISModel = window.ucis;

const UcMetricEvent = {
    ConsentRenderedFailed : "620",
    ConsentRenderedFailedMsg : "Invalid Model"
};

export const FallbackUI: React.FC = () => {
    // Redirect to Login flow.
    window.location.replace(encodeURI(ucisData.RedirectUrl));

    return (
        null
    );
};

export const errorHandlerLearnMore = (error: Error, info: {componentStack: string}) => {
    // Log error to logging service
    const stackTrace = "ErrorName: " + error.name + " ErrorStackMessage: " + error.message + " ErrorStackTrace: " + error.stack + " ErrorInfoStackTrace: " + info.componentStack;
    logUCMetrics("LearnMoreRenderFailed", ucisData, stackTrace);
};

export const errorHandlerUCNotice = (error: Error, info: {componentStack: string}) => {
    // Log error to logging service
    const stackTrace = "ErrorName: " + error.name + " ErrorStackMessage: " + error.message + " ErrorStackTrace: " + error.stack + " ErrorInfoStackTrace: " + info.componentStack;
    logUCMetrics("ConsentRenderFailed", ucisData, UcMetricEvent.ConsentRenderedFailed, UcMetricEvent.ConsentRenderedFailedMsg, stackTrace);
};
